import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const RegisterManager = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [credits, setCredits] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [success, setSuccess] = useState(false);

  const axiosPrivate = useAxiosPrivate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrMsg("");
    setSuccess(false);

    try {
      await axiosPrivate.post(
        "/admin/register",
        JSON.stringify({ user, credits })
      );

      setSuccess(true);
      setUser("");
      setCredits("");

      setTimeout(() => {
        navigate("/admin");
      }, 1500);
    } catch (err) {
      console.error(err);
      if (err?.response?.status === 409) {
        setErrMsg("Username already exists");
      } else {
        setErrMsg(err?.response?.data?.message || err?.message);
      }
    }
  };

  return (
    <div className="fade-in" style={{ maxWidth: "600px", margin: "0 auto", padding: "2rem 1rem" }}>
      {/* Back Button */}
      <button
        className="btn-secondary"
        style={{ marginBottom: "1.5rem", padding: "0.5rem 1rem", fontSize: "0.875rem" }}
        onClick={() => navigate("/admin")}
      >
        ← Back to Dashboard
      </button>

      {/* Header */}
      <div style={{ marginBottom: "2rem", textAlign: "center" }}>
        <h1
          style={{
            fontSize: "2.5rem",
            fontWeight: "700",
            marginBottom: "0.5rem",
            background: "linear-gradient(135deg, var(--primary-purple-light), var(--accent-cyan))",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
          }}
        >
          Register Manager
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "1.125rem" }}>
          Create a new manager account and assign credits
        </p>
      </div>

      {/* Form Card */}
      <div className="card" style={{ padding: "2.5rem" }}>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="user">Manager Email</label>
            <input
              type="email"
              id="user"
              value={user}
              onChange={(e) => setUser(e.target.value)}
              placeholder="manager@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="credits">Initial Credits</label>
            <input
              type="number"
              id="credits"
              value={credits}
              onChange={(e) => setCredits(e.target.value)}
              placeholder="e.g. 100"
              required
              min="0"
            />
          </div>

          <button
            type="submit"
            className="btn-primary"
            style={{ width: "100%", marginTop: "1rem" }}
          >
            Create Account
          </button>
        </form>

        {errMsg && <p className="errmsg" style={{ marginTop: "1.5rem" }}>{errMsg}</p>}
        {success && (
          <div className="successmsg" style={{ marginTop: "1.5rem", textAlign: "center" }}>
            <p>✓ Manager registered successfully!</p>
            <p style={{ fontSize: "0.875rem", marginTop: "0.5rem" }}>Redirecting to dashboard...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RegisterManager;
